import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import { MensalOni } from 'types/Relatorios/Mensal';

// tema: dados-inicio — séries de anos análogos e faixas do ONI (cor de dado)
// Cores das 5 séries de anos análogos (mesma ordem do Figma: amarelo, azul,
// verde, vermelho, laranja) — sem constante equivalente no design system
// (paleta específica deste gráfico), então fixas aqui.
const SERIE_CORES = ['#ffd10a', '#5070dd', '#3fbe95', '#C22B1F', '#D17617'];

// Tons de fundo por faixa de intensidade do ONI (Fraco → Muito forte),
// crescendo em saturação — mesmo padrão visual do Figma (bandas empilhadas
// atrás das linhas). Sem legenda de cor explícita no design, então usamos
// tons claros o suficiente para não competir com as séries.
const FAIXA_CORES: Record<string, string> = {
  Fraco: 'rgba(255, 209, 10, 0.12)',
  Moderado: 'rgba(255, 159, 10, 0.14)',
  Forte: 'rgba(209, 118, 23, 0.16)',
  'Muito forte': 'rgba(194, 43, 31, 0.18)',
};
// tema: dados-fim

interface Props { data: MensalOni; }

export default function OniChart({ data }: Props) {
  const { periodos, faixas, series } = data;

  const option = {
    legend: { data: series.map((s) => s.nome), bottom: 0 },
    xAxis: { type: 'category', data: periodos },
    yAxis: { type: 'value' },
    series: [
      ...series.map((s, i) => ({
        name: s.nome,
        type: 'line',
        data: s.valores,
        color: SERIE_CORES[i % SERIE_CORES.length],
      })),
      {
        name: 'Faixas de intensidade',
        type: 'line',
        data: [],
        markArea: {
          silent: true,
          data: faixas.map((f) => ([
            { name: f.nome, yAxis: f.minimo, itemStyle: { color: FAIXA_CORES[f.nome] } },
            { yAxis: f.maximo },
          ])),
        },
      },
    ],
    tooltip: { trigger: 'axis' },
    grid: {
      left: '8%', right: '5%', top: '8%', bottom: '18%', containLabel: true,
    },
  };

  return <ReactECharts option={option} style={{ height: 280 }} />;
}
